/**
 * The build watermark: `#98 · web` in the bottom corner, quiet enough to forget and
 * legible enough to read across a room.
 *
 * It exists because three copies of this app can be running at once — a browser tab, an
 * installed PWA and the native shell — and until now nothing on the screen said which one
 * you were looking at or how old it was. A PWA is resumed rather than loaded, so it sits
 * deploys behind while looking healthy, and the native shell's page is frozen inside the
 * APK until somebody installs a new one. Every report from those devices is about code
 * nobody is running, and the only way to tell was to open Settings and read a commit hash.
 *
 * Not rendered during a sit. The screen someone is meditating in front of gets nothing
 * added to it, and a version number is the clearest possible example of something that
 * matters to the person shipping and not at all to the person sitting.
 */

import { buildMark } from './build-info';

export function BuildMark() {
  return (
    <span class="build-mark" data-testid="build-mark" aria-hidden="true">
      {buildMark()}
    </span>
  );
}
